export function isEmpty(value: string): boolean {
  if (
    !value ||
    value?.trim() === '' ||
    value === 'null' ||
    value === null ||
    value === undefined
  ) {
    return true;
  }
  return false;
}

export function toTitleCase(value: string): string {
  if (!isEmpty(value)) {
    // return value.split(' ')
    //   .map(s => s.slice(0, 1).toUpperCase() + s.slice(1).toLowerCase())
    //   .join(' ');
    return value.charAt(0).toUpperCase() + value.slice(1);
  } else {
    return value;
  }
}
